import { render, staticRenderFns } from "./paymentWallet.vue?vue&type=template&id=50177c78&scoped=true"
import script from "./paymentWallet.vue?vue&type=script&lang=js"
export * from "./paymentWallet.vue?vue&type=script&lang=js"
import style0 from "./paymentWallet.vue?vue&type=style&index=0&id=50177c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50177c78",
  null
  
)

export default component.exports